import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useRef } from 'react';
import { bool, func, oneOf, shape, string } from 'prop-types';
import { capitalize } from '../../../utils';
import { ClosePopper, Content, Icon, InfoContainer, Popper, SuccessContainer, Title, ZipCodeBtn, ZipcodeContainer } from './zipcode.styles';
import { Box } from '../../../atoms';
import { ZipcodeText } from '../../../molecules';

function ClosePopupBtn({
  onClick
}) {
  return /*#__PURE__*/React.createElement(ClosePopper, {
    "data-testid": "close-btn",
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Close",
    width: 24,
    height: 24,
    cursor: "pointer",
    "data-testid": "close"
  }));
}

process.env.NODE_ENV !== "production" ? ClosePopupBtn.propTypes = {
  onClick: func.isRequired
} : void 0;

const Zipcode = _ref => {
  let {
    onZipCodeClick,
    onClickPopperBtn,
    onClosePopper,
    onHoverZipCode,
    popperDisplay,
    popper
  } = _ref,
      zipcode = _objectWithoutPropertiesLoose(_ref, ["onZipCodeClick", "onClickPopperBtn", "onClosePopper", "onHoverZipCode", "popperDisplay", "popper"]);

  const parentRef = useRef(null);
  const {
    enabled: popperEnabled,
    info: {
      title: popperTitle,
      content: popperContent,
      buttonLabel: popperBtnLabel
    } = {},
    success: {
      title: popperSuccessTitle,
      content: popperSuccessContent
    } = {}
  } = popper;

  const renderInfoContent = () => {
    return /*#__PURE__*/React.createElement(InfoContainer, {
      "data-testid": "popper-info-container"
    }, /*#__PURE__*/React.createElement(ClosePopupBtn, {
      onClick: onClosePopper
    }), /*#__PURE__*/React.createElement(Title, null, popperTitle), /*#__PURE__*/React.createElement(Content, null, popperContent), /*#__PURE__*/React.createElement(ZipCodeBtn, {
      "data-testid": "popper-btn",
      onClick: onClickPopperBtn
    }, popperBtnLabel));
  };

  const renderSuccessContent = () => /*#__PURE__*/React.createElement(SuccessContainer, {
    "data-testid": "popper-success-container"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "DoneCircle",
    width: 32,
    height: 32,
    fill: "alert.success.text",
    "data-testid": "DoneCircle"
  }), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Title, null, popperSuccessTitle), /*#__PURE__*/React.createElement(Content, null, popperSuccessContent)), /*#__PURE__*/React.createElement(ClosePopupBtn, {
    onClick: onClosePopper
  }));

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ZipcodeContainer, {
    "data-testid": "zipcode-text-container",
    onClick: onZipCodeClick,
    ref: parentRef,
    onMouseEnter: onHoverZipCode
  }, /*#__PURE__*/React.createElement(ZipcodeText, _extends({}, zipcode, {
    formatter: capitalize
  }))), popperEnabled && /*#__PURE__*/React.createElement(Popper, {
    visible: !!popperDisplay,
    parentRef: parentRef
  }, popperDisplay === 'success' ? renderSuccessContent() : renderInfoContent()));
};

Zipcode.defaultProps = {
  popper: {
    enabled: false
  },
  onHoverZipCode: () => {}
};
process.env.NODE_ENV !== "production" ? Zipcode.propTypes = {
  popperDisplay: oneOf(['info', 'success', null]),
  onZipCodeClick: func,
  onClickPopperBtn: func,
  onClosePopper: func,
  onHoverZipCode: func,
  popper: shape({
    enabled: bool,
    info: shape({
      buttonLabel: string,
      content: string,
      title: string
    }),
    success: shape({
      content: string,
      title: string
    })
  })
} : void 0;
export default Zipcode;